export enum PUBLIC_PAGES {
  LOGIN = '/login',
}

export enum PRIVATE_PAGES {
  HOME = '/',
}
